@import 'vars';
@import 'typography/softphone';

.layout {
  position: relative;
  width: 100vw;
  padding-top: 55px;
  background: $light-grey;

  &--softphone {
    @include softphone-typography;

    position: fixed;
    padding: 0;
    max-width: $softphone-max-width;

    &__background {
      background: $light-grey;
      width: 100vw;
      height: 100vh;
      position: fixed;
      z-index: -1;
    }

    &--forced {
      max-width: $forced-softphone-max-width;
    }
  }
}
